import { render, staticRenderFns } from "./deletePrinterRuleRepair.vue?vue&type=template&id=2c82752c&scoped=true"
import script from "./deletePrinterRuleRepair.vue?vue&type=script&lang=js"
export * from "./deletePrinterRuleRepair.vue?vue&type=script&lang=js"
import style0 from "./deletePrinterRuleRepair.vue?vue&type=style&index=0&id=2c82752c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c82752c",
  null
  
)

export default component.exports